import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import './styles/global.css';

import Navbar from './components/Navbar';
import CustomCursor from './components/CustomCursor';
import SmoothScroll from './components/SmoothScroll';
import Preloader from './components/Preloader';
import { PageWrap } from './components/motion/primitives';
import Home from './pages/Home';
import Propel from './pages/Propel';
import Onboarding from './pages/Onboarding';
import Gamification from './pages/Gamification';
import TheBrief from './pages/TheBrief';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrap><Home /></PageWrap>} />
        <Route path="/propel" element={<PageWrap><Propel /></PageWrap>} />
        <Route path="/onboarding" element={<PageWrap><Onboarding /></PageWrap>} />
        <Route path="/gamification" element={<PageWrap><Gamification /></PageWrap>} />
        <Route path="/the-brief" element={<PageWrap><TheBrief /></PageWrap>} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div className="grain" aria-hidden="true" />
      <Preloader />
      <SmoothScroll />
      <CustomCursor />
      <Navbar />
      <AnimatedRoutes />
    </BrowserRouter>
  );
}
